import { css } from '@emotion/react';

import { DealProduct } from '../../../../types';

import ListItem from '../ListItem';
import DealProductStepper from '../../../../shared/DealProductStepper';

const stepper = css`
  .title {
    line-height: 30px;
  }
`;

interface Props {
  dealProduct: DealProduct;
  isPurchaseStatus: boolean;
  isSoldOut: boolean;
}

export default function SingleDeal({
  dealProduct,
  isPurchaseStatus,
  isSoldOut,
}: Props) {
  if (!isPurchaseStatus || isSoldOut) {
    return null;
  }

  return (
    <ListItem
      title="구매수량"
      css={stepper}
    >
      <DealProductStepper dealProduct={dealProduct} />
    </ListItem>
  );
}
